export default __webpack_public_path__ + "static/magdalanaj-42b3895cbf4e55f7080b7f56ba07c9d1.jpg";